import { createContext, useContext, useEffect, useState } from "react";
import { LANGS, translations } from "./translations";

const KEY = "synrise-lang";
const codes = LANGS.map((l) => l.code);

const detect = () => {
  try {
    const saved = localStorage.getItem(KEY);
    if (codes.includes(saved)) return saved;
  } catch (e) {}
  const prefs = (navigator.languages || [navigator.language || ""]).map((l) => (l || "").slice(0, 2).toLowerCase());
  return prefs.find((l) => codes.includes(l)) || "it";
};

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (code) => {
    setLangState(code);
    try { localStorage.setItem(KEY, code); } catch (e) {}
  };

  return <LangCtx.Provider value={{ lang, setLang, t: translations[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
